import {generateGuid} from './utility.js';

const page_toasts = new Map();

export function addToast({type, message, heading}, dismiss_delay = 5000) {
    type = ['error', 'success'].includes(type) ? type : 'error';
    if (type === 'error') {
        heading = heading ?? 'Error';
    } else {
        heading = heading ?? '';
    }

    const toast_id = "toast-" + generateGuid(),
        auto_hide = dismiss_delay > 0 ? 'true' : 'false',
        toast_html = `<div data-toast-type="${type}" class="toast rounded" role="alert" aria-live="assertive" aria-atomic="true" id="${toast_id}" data-bs-autohide="${auto_hide}" data-bs-delay="${dismiss_delay}">
                                  <div class="toast-header rounded-top">
                                    <strong class="me-auto">${heading}</strong>
                                    <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
                                  </div>
                                  <div class="toast-body rounded-bottom">${maggieland.nl2br(decodeURIComponent(message))}</div>
                            </div>`;
    
    // add to DOM
    $("#toast-container").append(toast_html);

    // get el from DOM
    const el_toast = document.getElementById(toast_id);

    // attach listener
    el_toast.addEventListener('hidden.bs.toast', () => {
        $(`#${toast_id}`).remove();

        // remove item from the map
        page_toasts.delete(toast_id);
    });

    const bs_toast = bootstrap.Toast.getOrCreateInstance(el_toast);
    bs_toast.show();

    page_toasts.set(toast_id, bs_toast);
}

export function removeToast(toast_id) {
    // trigger event to each toast
    page_toasts.get(toast_id)?.hide();
}

export function removeAllToasts() {
    // trigger hidden event to each toast
    page_toasts.forEach(function (bs_toast, toast_id) {
        removeToast(toast_id);
    });
}